import type { SessionData } from '~/types/sessionData';

export const checkTokenValidity = (decodedToken: SessionData, remainingMinutes: number = 0) => {
  // console.log('checkTokenValidity::decodedToken: ', decodedToken);
  if (!decodedToken || !decodedToken.exp) return false;
  // Date.now() generates epoch dates with milliseconds
  return decodedToken.exp + (remainingMinutes * 60) > Date.now() / 1000;
};
